var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('meta',{attrs:{"content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0","name":"viewport"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }